module.exports = __webpack_public_path__ + "static/media/workshop-4515582_1920.48db74f4.jpg";